/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import ValidateAccessToken from '@/components/controllers/auth/ValidateAccessToken'
import Sidebar from '@/components/Sidebar'
import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'

import { validateSearchBreadcrumbs } from '@/components/ui/BreadcrumbNav'

export const Route = createFileRoute('/_authenticated')({
    component: RouteComponent,
    validateSearch: validateSearchBreadcrumbs
})

function RouteComponent() {
    const location = useLocation();
    const { bc } = Route.useSearch();

    return <ValidateAccessToken location={location} >
        <main className="fixed flex flex-row w-full h-full">
            <div className="flex flex-row">
                <Sidebar breadcrumbs={bc} />
            </div>
            <div className="flex flex-col justify-between w-full overflow-y-auto">
                <Outlet />
            </div>
        </main>
    </ValidateAccessToken>
}
